import { useMutation, useQueryClient } from "@tanstack/react-query"

import { v1RequestRide } from "@be-miniapp/api"

import type { RideBookingPayload } from "../utils/ride-booking"

export function useRequestRideMutation(params: {
  buildPayload: () => RideBookingPayload
  formUrlEncoded: boolean
  onSuccess: (resp: Awaited<ReturnType<typeof v1RequestRide>>) => void
  onError: (err: unknown) => void
}) {
  const { buildPayload, formUrlEncoded, onSuccess, onError } = params
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      queryClient.removeQueries({
        queryKey: ["current-user-sessions"],
      })

      const payload = buildPayload()
      return v1RequestRide(payload, { formUrlEncoded })
    },
    onSuccess,
    onError,
  })
}
